<div class="ssm-backdrop" (click)="close.emit()">
  <div class="ssm-card" role="dialog" aria-modal="true" aria-label="Detalle de tus puntos" (click)="$event.stopPropagation()">
    <div class="ssm-shapes" aria-hidden="true">
      <div class="ssm-shape ssm-shape--a"></div>
      <div class="ssm-shape ssm-shape--b"></div>
    </div>

    <header class="ssm-header">
      <span class="ssm-star">⭐</span>
      <div class="ssm-total-text">
        <p class="ssm-total-label">{{ 'GAMIFICATION.SMART_SCORE' | translate }}</p>
        <p class="ssm-total-value">{{ summary?.smartScore ?? 0 | number }}</p>
      </div>
      <button type="button" class="ssm-close" (click)="close.emit()" aria-label="Cerrar">✕</button>
    </header>

    <!-- Las tres monedas, como las mini tarjetas del Inicio -->
    <div class="ssm-coins">
      <div class="ssm-coin" *ngFor="let key of dimensionOrder" [attr.data-coin]="key">
        <span class="ssm-coin-body">
          <span class="ssm-coin-icon">{{ dimensions[key].emoji }}</span>
          <strong class="ssm-coin-value">{{ valueFor(key) | number }}</strong>
          <span class="ssm-coin-label">{{ dimensions[key].label }}</span>
        </span>
      </div>
    </div>

    <section class="ssm-panel">
      <h3 class="ssm-title">{{ 'GAMIFICATION.TODAY' | translate }}</h3>

      <div class="ssm-row" *ngFor="let row of dailyRows" [attr.data-coin]="row.key">
        <div class="ssm-row-head">
          <span>{{ row.meta.emoji }} {{ row.meta.label }}</span>
          <span class="ssm-row-count">{{ row.earned }} / {{ row.cap }}</span>
        </div>
        <div class="ssm-track"><div class="ssm-fill" [style.width.%]="row.percent"></div></div>
        <p class="ssm-hint">
          <ng-container *ngIf="row.remaining > 0">Te quedan {{ row.remaining }}</ng-container>
          <ng-container *ngIf="row.remaining === 0">{{ 'GAMIFICATION.CAP_REACHED' | translate }}</ng-container>
          <ng-container *ngIf="row.key === 'vitalis' && summary?.daily?.vitalisPausesToday !== undefined"> · {{ summary?.daily?.vitalisPausesToday }}/{{ summary?.daily?.vitalisPausesCap }} pausas premiadas</ng-container>
          <ng-container *ngIf="row.key === 'pulse' && summary?.daily?.pulseGamesToday !== undefined"> · duelos {{ summary?.daily?.pulseGamesToday }}/{{ summary?.daily?.pulseGamesCap }} · equipo {{ summary?.daily?.pulseTeamGamesToday ?? 0 }}/{{ summary?.daily?.pulseGamesCap }}</ng-container>
        </p>
      </div>
    </section>

    <section class="ssm-panel ssm-panel--karma">
      <div class="ssm-row" data-coin="karma">
        <div class="ssm-row-head">
          <span>💜 Karma del mes</span>
          <span class="ssm-row-count">{{ summary?.karma?.givenThisMonth ?? 0 }} / {{ summary?.karma?.monthlyAllowance ?? 0 }}</span>
        </div>
        <div class="ssm-track"><div class="ssm-fill" [style.width.%]="karmaPercent"></div></div>
        <p class="ssm-hint">Te quedan {{ karmaRemaining }} para regalar</p>
      </div>
    </section>
  </div>
</div>
